import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type ChatRoomFor400FOaOnRequestFileUploadForOaModalQueryVariables = Types.Exact<{
  roomId: Types.Scalars['ID']['input'];
}>;


export type ChatRoomFor400FOaOnRequestFileUploadForOaModalQuery = { __typename?: 'Query', ownChatRoom?: { __typename?: 'ChatRoom', id: string, userUploadPageUrl?: string | null, filesFor400FOa: Array<{ __typename?: 'ChatRoomFile', id: string, name: string, size: number, uploadedAt: TimeString }> } | null };

export type IssueFileDownloadUrlOnRequestFileUploadForOaModalMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type IssueFileDownloadUrlOnRequestFileUploadForOaModalMutation = { __typename?: 'Mutation', for400FOA__issueFileDownloadURL: string };

export type SendFileDownloadUrlOnRequestFileUploadForOaModalMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type SendFileDownloadUrlOnRequestFileUploadForOaModalMutation = { __typename?: 'Mutation', for400FOA__sendFileDownloadURL: { __typename?: 'For400FOASendFileDownloadURLPayload', isSucceeded: boolean } };


export const ChatRoomFor400FOaOnRequestFileUploadForOaModalDocument = gql`
    query chatRoomFor400FOaOnRequestFileUploadForOAModal($roomId: ID!) {
  ownChatRoom(id: $roomId) {
    id
    filesFor400FOa {
      id
      name
      size
      uploadedAt
    }
    userUploadPageUrl
  }
}
    `;

/**
 * __useChatRoomFor400FOaOnRequestFileUploadForOaModalQuery__
 *
 * To run a query within a Vue component, call `useChatRoomFor400FOaOnRequestFileUploadForOaModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatRoomFor400FOaOnRequestFileUploadForOaModalQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useChatRoomFor400FOaOnRequestFileUploadForOaModalQuery({
 *   roomId: // value for 'roomId'
 * });
 */
export function useChatRoomFor400FOaOnRequestFileUploadForOaModalQuery(variables: ChatRoomFor400FOaOnRequestFileUploadForOaModalQueryVariables | VueCompositionApi.Ref<ChatRoomFor400FOaOnRequestFileUploadForOaModalQueryVariables> | ReactiveFunction<ChatRoomFor400FOaOnRequestFileUploadForOaModalQueryVariables>, options: VueApolloComposable.UseQueryOptions<ChatRoomFor400FOaOnRequestFileUploadForOaModalQuery, ChatRoomFor400FOaOnRequestFileUploadForOaModalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ChatRoomFor400FOaOnRequestFileUploadForOaModalQuery, ChatRoomFor400FOaOnRequestFileUploadForOaModalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ChatRoomFor400FOaOnRequestFileUploadForOaModalQuery, ChatRoomFor400FOaOnRequestFileUploadForOaModalQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ChatRoomFor400FOaOnRequestFileUploadForOaModalQuery, ChatRoomFor400FOaOnRequestFileUploadForOaModalQueryVariables>(ChatRoomFor400FOaOnRequestFileUploadForOaModalDocument, variables, options);
}
export function useChatRoomFor400FOaOnRequestFileUploadForOaModalLazyQuery(variables?: ChatRoomFor400FOaOnRequestFileUploadForOaModalQueryVariables | VueCompositionApi.Ref<ChatRoomFor400FOaOnRequestFileUploadForOaModalQueryVariables> | ReactiveFunction<ChatRoomFor400FOaOnRequestFileUploadForOaModalQueryVariables>, options: VueApolloComposable.UseQueryOptions<ChatRoomFor400FOaOnRequestFileUploadForOaModalQuery, ChatRoomFor400FOaOnRequestFileUploadForOaModalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ChatRoomFor400FOaOnRequestFileUploadForOaModalQuery, ChatRoomFor400FOaOnRequestFileUploadForOaModalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ChatRoomFor400FOaOnRequestFileUploadForOaModalQuery, ChatRoomFor400FOaOnRequestFileUploadForOaModalQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ChatRoomFor400FOaOnRequestFileUploadForOaModalQuery, ChatRoomFor400FOaOnRequestFileUploadForOaModalQueryVariables>(ChatRoomFor400FOaOnRequestFileUploadForOaModalDocument, variables, options);
}
export type ChatRoomFor400FOaOnRequestFileUploadForOaModalQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ChatRoomFor400FOaOnRequestFileUploadForOaModalQuery, ChatRoomFor400FOaOnRequestFileUploadForOaModalQueryVariables>;
export const IssueFileDownloadUrlOnRequestFileUploadForOaModalDocument = gql`
    mutation issueFileDownloadURLOnRequestFileUploadForOAModal($id: ID!) {
  for400FOA__issueFileDownloadURL(chatRoomFileId: $id)
}
    `;

/**
 * __useIssueFileDownloadUrlOnRequestFileUploadForOaModalMutation__
 *
 * To run a mutation, you first call `useIssueFileDownloadUrlOnRequestFileUploadForOaModalMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useIssueFileDownloadUrlOnRequestFileUploadForOaModalMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useIssueFileDownloadUrlOnRequestFileUploadForOaModalMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useIssueFileDownloadUrlOnRequestFileUploadForOaModalMutation(options: VueApolloComposable.UseMutationOptions<IssueFileDownloadUrlOnRequestFileUploadForOaModalMutation, IssueFileDownloadUrlOnRequestFileUploadForOaModalMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<IssueFileDownloadUrlOnRequestFileUploadForOaModalMutation, IssueFileDownloadUrlOnRequestFileUploadForOaModalMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<IssueFileDownloadUrlOnRequestFileUploadForOaModalMutation, IssueFileDownloadUrlOnRequestFileUploadForOaModalMutationVariables>(IssueFileDownloadUrlOnRequestFileUploadForOaModalDocument, options);
}
export type IssueFileDownloadUrlOnRequestFileUploadForOaModalMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<IssueFileDownloadUrlOnRequestFileUploadForOaModalMutation, IssueFileDownloadUrlOnRequestFileUploadForOaModalMutationVariables>;
export const SendFileDownloadUrlOnRequestFileUploadForOaModalDocument = gql`
    mutation sendFileDownloadURLOnRequestFileUploadForOAModal($id: ID!) {
  for400FOA__sendFileDownloadURL(chatRoomFileId: $id) {
    isSucceeded
  }
}
    `;

/**
 * __useSendFileDownloadUrlOnRequestFileUploadForOaModalMutation__
 *
 * To run a mutation, you first call `useSendFileDownloadUrlOnRequestFileUploadForOaModalMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSendFileDownloadUrlOnRequestFileUploadForOaModalMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSendFileDownloadUrlOnRequestFileUploadForOaModalMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useSendFileDownloadUrlOnRequestFileUploadForOaModalMutation(options: VueApolloComposable.UseMutationOptions<SendFileDownloadUrlOnRequestFileUploadForOaModalMutation, SendFileDownloadUrlOnRequestFileUploadForOaModalMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SendFileDownloadUrlOnRequestFileUploadForOaModalMutation, SendFileDownloadUrlOnRequestFileUploadForOaModalMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SendFileDownloadUrlOnRequestFileUploadForOaModalMutation, SendFileDownloadUrlOnRequestFileUploadForOaModalMutationVariables>(SendFileDownloadUrlOnRequestFileUploadForOaModalDocument, options);
}
export type SendFileDownloadUrlOnRequestFileUploadForOaModalMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SendFileDownloadUrlOnRequestFileUploadForOaModalMutation, SendFileDownloadUrlOnRequestFileUploadForOaModalMutationVariables>;